import React, { useEffect, useState } from "react";
import axios from "axios";
import NoListProv from "./NoListProv/NoListProv";
import Swal from "sweetalert2";
import "./ListProv.css";
import { FaClipboardList } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import NavbarProveedor from "../NavbarProveedor/NavbarProveedor";
import FooterIndex from "../../components/footerHomePage/footerHomePage";

const ListProv = () => {
  const [salesData, setSalesData] = useState(null);
  const [load, setLoad] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectYear, setSelectYear] = useState("");
  const location = useLocation();
  let data = location.state;

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  useEffect(() => {
    setLoad(true);
    const id = data.id;
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BRING_INVOICE_PROVEEDOR}/${id}`
        );

        if (response.status === 204) {
          setLoad(false);
          setSalesData(null);
        } else {
          setLoad(false);
          setSalesData(response.data.invoice);
        }
      } catch (error) {
        setLoad(false);
        setSalesData(null);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectYear(event.target.value);
  };

  const handleFilterClick = async () => {
    setLoad(true);
    const id = data.id;
    const monthString = selectedMonth;
    const year = selectYear;

    if (monthString === "" || year === "") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor seleccione mes y año",
      });
      setLoad(false);
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BRING_SEARCH_INVOICE_PROVEEDOR}`,
        {
          params: {
            id: id,
            month: monthString,
            year: year,
          },
        }
      );

      if (response.status === 204) {
        setLoad(false);
        setSalesData(null);
      } else {
        setLoad(false);
        setSalesData(response.data.invoiceValue);
      }
    } catch (error) {
      setLoad(false);
      setSalesData(null);
    }
  };

  return (
    <>
      <div>
        <NavbarProveedor />
        <div className="boxfilter">
          <select
            className="selectfilterprov"
            value={selectYear}
            onChange={handleYearChange}
          >
            <option value="">Selecciona un año</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
            <option value="2030">2030</option>
          </select>

          <select
            className="selectfilterprov"
            value={selectedMonth}
            onChange={handleMonthChange}
          >
            <option value="">Selecciona un mes</option>
            <option value="Enero">Enero</option>
            <option value="Febrero">Febrero</option>
            <option value="Marzo">Marzo</option>
            <option value="Abril">Abril</option>
            <option value="Mayo">Mayo</option>
            <option value="Junio">Junio</option>
            <option value="Julio">Julio</option>
            <option value="Agosto">Agosto</option>
            <option value="Septiembre">Septiembre</option>
            <option value="Octubre">Octubre</option>
            <option value="Noviembre">Noviembre</option>
            <option value="Diciembre">Diciembre</option>
          </select>

          <button className="buttonfilteradmin" onClick={handleFilterClick}>
            Filtrar
          </button>
        </div>

        {!load ? (
          <>
            {salesData !== null ? (
              <div>
                <div className="backgounrdprovee">
                  <div className="allboxlistprov">
                    <div className="alllistprov">
                      <div className="headerlistprov">
                        <p className="infoprovlistletter leftlistprev firsttittle">
                          Monto
                        </p>
                        <p className="infoprovlistletter leftlistprev">
                          Nº Factura
                        </p>
                        <p className="infoprovlistletter leftlistprev">Total</p>
                        <p className="infoprovlistletter leftlistprev">Fecha</p>
                        <p className="infoprovlistletter leftlistprev">CBU</p>
                        <p className="infoprovlistletter leftlistprev lastittle">
                          Observaciones
                        </p>
                      </div>

                      {salesData &&
                        salesData.map((sale, index) => (
                          <div className="headerlistprov" key={index}>
                            <p className="infoprovlistletter leftlistprev2 firsttittle">
                              ${sale.amountToBeTransferred}
                            </p>
                            <p className="infoprovlistletter bottonlistprev2">
                              {sale.numberInvoice}
                            </p>
                            <p className="infoprovlistletter leftlistprev2">
                              ${sale.amountToBeTransferred}
                            </p>
                            <p className="infoprovlistletter leftlistprev2">
                              {sale.createAt}
                            </p>
                            <p className="infoprovlistletter leftlistprev2">
                              {sale.cbu}
                            </p>
                            <p className="infoprovlistletter leftlistprev2">
                              {sale.observation}
                            </p>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <NoListProv
                title="La información de este mes no se ha subido aún."
                Icon={FaClipboardList}
              />
            )}
            <FooterIndex />
          </>
        ) : (
          <div className="loader"></div>
        )}
      </div>
    </>
  );
};

export default ListProv;
